import type {
  BuyerCouponProductsDataSource,
  GetBuyerCouponProductsParams,
} from '~/api/data-source/buyer-coupon-products';
import { buyerCouponProductsDataSource } from '~/api/data-source/buyer-coupon-products';
import type { BuyerCouponProducts } from '~/api/model';
import { buyerCouponProductsSchema, parseModel } from '~/api/model';

export interface BuyerCouponProductsRepository {
  getBuyerCouponProducts(
    params: GetBuyerCouponProductsParams,
  ): Promise<BuyerCouponProducts>;
}

export class BuyerCouponProductsRepositoryImpl
  implements BuyerCouponProductsRepository
{
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: BuyerCouponProductsDataSource = buyerCouponProductsDataSource,
  ) {}

  async getBuyerCouponProducts(params: GetBuyerCouponProductsParams) {
    const response = await this.dataSource.getBuyerCouponProducts(params);
    return parseModel(
      buyerCouponProductsSchema,
      response,
      'BuyerCouponProducts',
    );
  }
}

export const buyerCouponProductsRepository =
  new BuyerCouponProductsRepositoryImpl();
